.select-field-type
    select.field-type-dropdown
    .remove
        a.btn.btn-link.control-link(data-action='removeField' title='Remove')
            i.fa.fa-trash